import { Col, Container, Row } from 'styled-bootstrap-grid';
import data from '../../data/eyecandy';
import React from 'react';
import styled from 'styled-components';
import Tile from '../../../Tile/components/Tile';
import Heading from "../../../Typography/components/Heading";
import Title from "../../../Typography/components/Title";

const EyecandyWrapper = styled.div`
  background: #fff;
  margin-top: 2rem;
  padding: 2rem 0;
`;
const StyledContainer = styled(Container)`
  padding-top: 8rem;
  padding-bottom: 8rem;
`;
const StyledCol = styled(Col)`
  margin-bottom: 2rem;
`;

const Eyecandy = () => {
  const EyecandyItems = data.map((eyecandy, i) => {
    return <StyledCol col={6} md={4} key={i}>
      <Tile component="Portfolio" aspectRatio="4:3" {...eyecandy} />
    </StyledCol>;
  });

  return <EyecandyWrapper>
    <StyledContainer>
      <Row>
        <StyledCol col={12}>
          <Heading level={3}>Creative samples</Heading>
          <Title level={4}>See our work on Dribbble.</Title>
        </StyledCol>
      </Row>
      <Row>
        {EyecandyItems}
      </Row>
    </StyledContainer>
  </EyecandyWrapper>;
};

export default Eyecandy;
